/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const LocationArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Location Arrow"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M18.278 2.228 3.598 8.611c-2.53 1.1-1.911 4.851.838 5.08l5.42.452.453 5.42c.229 2.75 3.98 3.369 5.08.839l6.383-14.68c.96-2.21-1.283-4.454-3.494-3.494"
      className="SVG"
    />
  </svg>
);

export const LocationArrowIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'location-arrow-icon'}
      icon={LocationArrow}
      {...props}
      size={size}
    />
  );
};
